import { embedDashboard } from '@superset-ui/embedded-sdk';
import axios, { AxiosResponse } from 'axios';
import useLoader from 'hooks/useLoader';
import { useEffect, useRef } from 'react';
import Swal from 'sweetalert2';

function WorkflowWaitingTimeViewModel() {
    const screenLoader = useLoader();
    const dashboardRef = useRef<HTMLDivElement>(null);

    const token = '6f8cc615-6cca-41fa-92c5-fdd94ca3cbbf';
    const supersetDomain = 'https://athena.focusonesoftware.com';

    useEffect(() => {
        loginAthna();
    }, []);

    const loginAthna = async () => {
        try {
            screenLoader.show();

            const bodyData = {
                provider: 'db',
                username: 'embedded',
                password: 'AG1q2w3e4r',
                refresh: true
            };

            const response: AxiosResponse<{ access_token: string; refresh_token: string }> =
                await axios.post(supersetDomain + '/api/v1/security/login', bodyData, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

            const csrfToken = await getCsrfToken(response.data.access_token);

            const guestToken = await getGuestToken(
                response.data.access_token,
                csrfToken!,
                supersetDomain + '/api/v1/security/csrf_token/'
            );

            await embed(guestToken!);
        } catch (error) {
            if (error instanceof Error) {
                Swal.fire('Cannot get transport request!', error.message, 'error');
            }
        } finally {
            screenLoader.hide();
        }
    };

    const getCsrfToken = async (accessToken: string) => {
        try {
            screenLoader.show();

            const response: AxiosResponse<{ result: string }> = await axios.get(
                supersetDomain + '/api/v1/security/csrf_token/',
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );

            return response.data.result;
        } catch (error) {
            if (error instanceof Error) {
                Swal.fire('Cannot get transport request!', error.message, 'error');
            }
        } finally {
            screenLoader.hide();
        }
    };

    const getGuestToken = async (accessToken: string, csrfToken: string, referer: string) => {
        try {
            screenLoader.show();
            const bodyData = {
                resources: [
                    {
                        type: 'dashboard',
                        id: '13'
                    }
                ],
                rls: [],
                user: {
                    username: 'embedded',
                    first_name: 'embedded',
                    last_name: 'embedded'
                }
            };

            const response: AxiosResponse<{ token: string }> = await axios.post(
                supersetDomain + '/api/v1/security/guest_token/',
                bodyData,
                {
                    params: {
                        Referer: referer,
                        'X-CSRFToken': csrfToken
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );

            return response.data.token;
        } catch (error) {
            if (error instanceof Error) {
                Swal.fire('Cannot get transport request!', error.message, 'error');
            }
        } finally {
            screenLoader.hide();
        }
    };

    const embed = async (guestToken: string) => {
        if (dashboardRef.current) {
            await embedDashboard({
                id: token,
                supersetDomain: supersetDomain,
                mountPoint: dashboardRef.current,
                fetchGuestToken: async () => guestToken,
                dashboardUiConfig: {
                    hideTitle: true,
                    hideTab: true,
                    hideChartControls: true,
                    filters: {
                        expanded: false,
                        visible: false
                    }
                }
            });
        }
    };

    return { dashboardRef };
}

export default WorkflowWaitingTimeViewModel;
